import * as React from 'react'
import PropTypes from 'prop-types'
import useInViewPort from '../../hooks/useInViewPort'

// const extractYouTubeID = url => {
//   const regex =
//     /(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i
//   const match = url.match(regex)
//   return match ? match[1] : null
// }

const extractYouTubeID = url => {
  // extract video id from YouTube URL
  // NOTE: used this code https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/\/?|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[2].length === 11 ? match[2] : null
}

const autoplayYouTubeVideoUrl = url => {
  const videoId = extractYouTubeID(url)
  return `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&autoplay=1&mute=1&controls=0&loop=1&disablekb=1&widget_referrer&allowautoplay&rel=0`
}

const IFrame = ({ src, title, className, placeholder = <></>, iframeClassName = 'border-2' }) => {
  const [nodeRef, isVisible] = useInViewPort()
  return (
    <div ref={nodeRef} className={className}>
      {isVisible ? (
        <iframe
          title={title}
          src={src}
          width="100%"
          height="100%"
          className={iframeClassName}
          allowFullScreen={true}
          loading="lazy"
        />
      ) : (
        placeholder
      )}
    </div>
  )
}

const YouTube = IFrame

IFrame.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.node,
  iframeClassName: PropTypes.string,
}

YouTube.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.node,
  iframeClassName: PropTypes.string,
}

YouTube.defaultProps = {
  src: '',
  title: '',
  className: '',
  placeholder: <></>,
  iframeClassName: 'border-2',
}

export { IFrame, extractYouTubeID, autoplayYouTubeVideoUrl }
export default YouTube
